/**
 * singup.jsx url: /singup
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 * import ErrorMessage for displaying error messages
 */
import React, {useState} from "react";
import axios from "axios";
import {Link, useHistory} from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../style/signupStyle.css';
import ErrorMessage from "../Misc/ErrorMessage";


function Signup() {
    /** keep track of error messages */
    const [errorMessage, setErrorMessage] = useState(null);
    /** history is used for redirecting the user */
    const history = useHistory();
    /**
     * singup is used for creating a new user account
     * name, emial, password, and password verify are passed from signup form
     */
    async function signup(e) {
        e.preventDefault();
        const formPasswordVerify = e.target.passVerify.value;
        const formName = e.target.name.value;
        const formEmail = e.target.email.value;
        const formPassword = e.target.firstPass.value;

        const signupData = {
            name: formName,
            email: formEmail,
            password: formPassword,
            passwordVerify: formPasswordVerify
        }

            try {
                await axios.post("https://link2rsvp.herokuapp.com/auth/", signupData);
            } catch (err) {
                if (err.response) {
                    if (err.response.data.errorMessage) {
                        setErrorMessage(err.response.data.errorMessage);
                    }
                }
                return;
            }
            
        

        history.push("/login");
    }


    return (
          
    <div>
        {
                errorMessage &&  (
                <ErrorMessage 
                message={errorMessage} 
                clear={() => setErrorMessage(null)}
                />
                )}
        

        <div id="signup">
        <h2 id="createHead">Create a new account</h2> 

        <Form onSubmit={signup}>
            <Row className="row">
                <Col>
                    <label htmlFor="name">Enter a Name</label>
                    <input
                    name="name"
                    id="name"
                    placeholder="Name"
                    type="text"
                    //value={formName}
                    //onChange={(e) => setFormName(e.target.value)}
                    />
                </Col>
                <Col>
                    <label htmlFor="email">Enter an Email</label>
                    <input
                    name="email"
                    id="email"
                    placeholder="Email Address"
                    type="email"
                    //value={formEmail}
                    //onChange={(e) => setFormEmail(e.target.value)}
                    />
                </Col>
            </Row>
            <Row className="row">
                <Col>
                    <label htmlFor="firstPass">Enter a Password</label>
                    <input
                    name="firstPass"
                    placeholder="password"
                    type="password"
                    id="firstPass"
                    //value={formPassword}
                    //onChange={(e) => setFormPassword(e.target.value)}
                    />
                    <Form.Text className="text-muted">
                         must be 6 or more characters.
                    </Form.Text>
                </Col>
                <Col>
                    <label htmlFor="passVerify">Re-enter your Password</label>
                    <input
                    name="passVerify"
                    placeholder="confrim password"
                    type="password"
                    id="passVerify"
                    //value={formPasswordVerify}
                    //onChange={(e) => setFormPasswordVerify(e.target.value)}
                    />
                </Col>
            </Row>
            <Button type="submit" className="create" variant="secondary" style={{backgroundColor: "#890E32"}}>Sign Up</Button>
        </Form>
        
        <p>
            Aready have an account? <Link to="/login">Login</Link>
        </p>
        </div>
</div>
    );
}
export default Signup;